export const MenuActions = {
  VIEW: "view",
  PREVIEW: "preview",
  EDIT: "edit",
  DUPLICATE: "duplicate",
  DELETE: "delete",
  UNPUBLISH: "unpublish",
  RESCHEDULE_PUBLISH: "reschedule_publish",
  CANCEL_PUBLISH: "cancel_publish",
  RESCHEDULE_UNPUBLISH: "reschedule_unpublish",
  CANCEL_UNPUBLISH: "cancel_unpublish",
  APPROVAL_STATUS: "approval_status",
  SHARE_WITH_BRANDS: "share_with_brands",
};

export const CARD_MENUS = {
  EDIT: {
    displayName: "Edit",
    permission: "page.edit",
  },
  DUPLICATE: {
    displayName: "duplicate",
    permission: "page.duplicate",
  },
  DELETE: {
    displayName: "delete",
    permission: "page.delete",
  },
  UNPUBLISH: {
    displayName: "Unpublish",
    permission: "page.publish",
  },
  RESCHEDULE_PUBLISH: {
    displayName: "reschedule_publish",
    permission: "page.publish",
  },
};
